export const getPositionOfAscendantInDivisionalChart = (divisionalPositionArray) => {
  for (const dataBlock of divisionalPositionArray) {
    for (const planetData of dataBlock.planet_positions) {
      if (planetData.planet.name === "Ascendant") {
        return parseInt(planetData.rasi.id) + 1;
      }
    }
  }
  return null; // Return null if Ascendant not found
};
